import {DataDogLogger, getLogger} from "../../../utils/logger";

interface ILoggerParams {
    userContext: any;
    config: {
        dataDogClientToken: string
    };
}

const initialState: DataDogLogger = {
    token: "",
    config: {},
    userContext: {},
    service: "",
    log: console.log,
    error: console.error,
    info: console.info,
    warn: console.warn
};

export function logger (state = initialState, action:any) {
    return state
}
